import React, { useRef, useState, useEffect } from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Table } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import Pagination from '../../../layout/Pagination'
import { layoutMobileMediaQuery } from '../../../layout/layoutConstants'
import { getEffectivenessReportTab } from '../../../components/constants/effectivenessReportTabs'
import GoogleIcon from '../../../icon/GoogleIcon'
import EffectivenessReportEmptyState from '../components/EffectivenessReportEmptyState'

const DetailsTable = ({
  data = [],
  currentPage,
  totalPages,
  handlePaginationClick,
  onSearchQuery,
  searchQuery,
  onRowClick,
  headers = [],
  renderRow,
  placeholder = 'Buscar usuario por código o nombre...',
  title = 'Detalles de reporte:',
  effectivenessTabKey,
  filterContent = null,
  shouldShowReset = false,
  onResetFilters = null
}) => {
  const isMobileLayout = useMediaQuery(layoutMobileMediaQuery)
  const searchInput = useRef(null)
  const [query, setQuery] = useState(searchQuery || '')

  useEffect(() => {
    if (searchInput.current) {
      searchInput.current.value = searchQuery || ''
    }
    setQuery(searchQuery || '')
  }, [searchQuery])

  const handleSearch = (e) => {
    if (e.key === 'Enter') {
      const value = searchInput.current.value.toLowerCase()
      setQuery(value)
      onSearchQuery(value)
    }
  }

  const deleteSearch = () => {
    setQuery('')
    searchInput.current.value = ''
    onSearchQuery('')
  }

  const effectivenessTabMeta =
    effectivenessTabKey != null && effectivenessTabKey !== ''
      ? getEffectivenessReportTab(effectivenessTabKey)
      : null
  const showEffectivenessEmpty =
    isMobileLayout && data.length === 0 && Boolean(effectivenessTabMeta)

  return (
    <div>
      <div className="col-12"></div>
      {filterContent ? (
        <div className="mt-30">
          <div className="report-index-title index-tab-report">{title}</div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 16,
              flexWrap: 'wrap',
              marginTop: 12
            }}
          >
            <div
              style={{
                flex: '1 1 320px',
                minWidth: 220,
                display: 'flex',
                alignItems: 'flex-start'
              }}
            >
              <GoogleIcon
                className="filter-icon-poc oc-icon-primary"
                name="page_info"
                size={22}
                style={{ marginTop: 10 }}
              />
              <div style={{ flex: 1, minWidth: 0 }}>{filterContent}</div>
            </div>
            <div
              className="input-group"
              style={{ flex: '1 1 280px', marginTop: 0, position: 'relative' }}
            >
              <input
                ref={searchInput}
                autoComplete="off"
                onKeyDown={handleSearch}
                className="report-search"
                style={{ fontSize: 12, marginLeft: 'auto' }}
                placeholder={placeholder}
              />
              {query === '' ? (
                <FontAwesomeIcon
                  icon={faMagnifyingGlass}
                  className="search-icon-reports"
                  style={{ marginTop: -1 }}
                />
              ) : (
                <div
                  title="Limpiar texto"
                  onClick={deleteSearch}
                  className="round-search-input-x-reports"
                >
                  X
                </div>
              )}
            </div>
          </div>
          {shouldShowReset && onResetFilters ? (
            <div
              onClick={onResetFilters}
              style={{
                marginTop: 16,
                marginBottom: 0,
                color: '#6b93bf',
                cursor: 'pointer',
                fontWeight: 400,
                display: 'inline-block'
              }}
            >
              Restablecer filtros aplicados
            </div>
          ) : null}
        </div>
      ) : (
        <div className="input-group mt-30">
          <div className="report-index-title index-tab-report">{title}</div>
          <input
            ref={searchInput}
            autoComplete="off"
            onKeyDown={handleSearch}
            className="report-search"
            style={{ fontSize: 12 }}
            placeholder={placeholder}
          />
          {query === '' ? (
            <FontAwesomeIcon
              icon={faMagnifyingGlass}
              className="search-icon-reports"
              style={{ marginTop: -1 }}
            />
          ) : (
            <div
              title="Limpiar texto"
              onClick={deleteSearch}
              className="round-search-input-x-reports"
            >
              X
            </div>
          )}
        </div>
      )}

      <div
        className={`report-index-table${filterContent ? ' report-index-table--with-filters' : ''}`}
      >
        <Table hover responsive>
          <thead className="table-header-gray-mui">
            <tr>
              {headers.map((header, index) => (
                <th
                  key={index}
                  className={['CÓDIGO', 'USUARIO'].includes(header.label) ? '' : 'text-center'}
                >
                  <div className="table-header-container" title={header.description}>
                    <span className="th-header-text">{header.label.toUpperCase()}</span>
                    <FontAwesomeIcon icon={faQuestionCircle} className="ml-2" />
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((model, index) => (
                <tr
                  key={index}
                  onClick={(e) => onRowClick(e, model.user_uid)}
                  style={{ cursor: 'pointer' }}
                >
                  {renderRow(model)}
                </tr>
              ))
            ) : showEffectivenessEmpty ? (
              <tr>
                <td colSpan={headers.length} className="border-0 p-3 align-middle">
                  <EffectivenessReportEmptyState tabValue={effectivenessTabKey} />
                </td>
              </tr>
            ) : (
              <tr>
                <td colSpan={headers.length}>No hay resultados</td>
              </tr>
            )}
          </tbody>
        </Table>

        {totalPages > 1 && (
          <Pagination
            current_page={currentPage}
            total_pages={totalPages}
            handle_pagination={handlePaginationClick}
          />
        )}
      </div>
    </div>
  )
}

export default DetailsTable
